/** "New from URL (AI)" entry point for the catalog list pages.
 *
 *  Renders nothing without the console_bg_ai_import perm. When the page has
 *  an active tenant filter, it pre-seeds the launch form's tenant picker.
 */
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import type { AiImportMode } from '@/api/aiImport';
import { usePermissions } from '@/hooks/usePermissions';

interface Props {
  type: AiImportMode;
  tenantId?: number | null;
}

export function AiImportEntryButton({ type, tenantId }: Props) {
  const { hasPerm } = usePermissions();
  if (!hasPerm('console_bg_ai_import')) return null;
  return (
    <Button
      variant="outlined"
      startIcon={<AutoAwesomeIcon />}
      component={RouterLink}
      to={`/ai-import?type=${type}${tenantId ? `&to=${tenantId}` : ''}`}
    >
      New from URL (AI)
    </Button>
  );
}
